import React, {Component} from "react";
import {connect} from 'react-redux';
import {Grid} from "@mui/material";
import AnnotationsExpandableList from "./AnnotationsExpandableList";
import {locateAnnotationOnMap} from "../utils/map_utils";
import {AnnotationsConstants} from "../../../utils/const";

class AnnotationsApp extends Component{

    initState = () => {
        this.mapState = this.props.mapsState[this.props.activeMapId];
        this.slideState = this.mapState.slideState;
        this.annotationState = this.props.mapsState[this.props.activeMapId].annotationState;
    }

    emptyComponent = () => <Grid>
        No Annotations Available
    </Grid>;

    render() {
        this.initState();
        if (!this.annotationState) return this.emptyComponent();

        let annotations = this.annotationState.annotations.filter(annotation => annotation.anno_drawer === 0);
        if(annotations.length === 0)
            return this.emptyComponent();

        return <AnnotationsExpandableList annotations={annotations}
                                          slideId={this.slideState.slide_data.id}
                                          onAnnotationClick={(annotation) =>
                                              locateAnnotationOnMap(this.slideState.slidemap, annotation)}
                                          colors={AnnotationsConstants.ANNO_COLORS}
                                          showDownload={true} />
    }
}

const mapStateToProps = (state) => {
    return {
        activeMapId: state.gammaStateReducer.activeMapId,
        mapsState: state.mapsStateReducer,
    }
}

export default connect(mapStateToProps)(AnnotationsApp)
